module.exports = __webpack_public_path__ + "static/media/accept_white.d9ed2b95.png";